import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplaintService } from 'src/app/_service/complaint.service';

@Component({
  selector: 'app-ipd-complaint-add-edit',
  templateUrl: './ipd-complaint-add-edit.component.html',
  styleUrls: ['./ipd-complaint-add-edit.component.css']
})
export class IpdComplaintAddEditComponent implements OnInit {

  userInformation: FormGroup; complaintForm: FormGroup; submitted: boolean = false; IpdId: any = ''; loading: boolean = false; myrole: string; ComplaintId: any = ''; s3url = '';
  complaintList: any = []; bdComplaintList: any = []; doctorComplaintList: any = []; hInfrastructureComplaintList: any = []; hStaffComplaintList: any = []; admissionComplaintList: any = []; dischargeComplaintList: any = []; otherComplaintList: any = [];
  hospital_infrastructure_comp_doc:string="";showDocs:boolean=false;
  constructor(private formBuilder: FormBuilder, private leadapi: LeadsService, private sharedapi: SharedService, private complaintapi: ComplaintService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.userInformation = this.formBuilder.group({
      'pname': [null],
      'treatment': [null],
      'docname': [null],
      'hospitalname': [null],
      'bd_name': [null],
    });

    this.complaintForm = this.formBuilder.group({
      'ipd_id': [null],
      'bd_com': [null],
      'doctor_com': [null],
      'hospital_infrastructure_com': [null],
      'hospital_staff_com': [null],
      'admission_com': [null],
      'discharge_com': [null],
      'others_com': [null],
      'hospital_infrastructure_com_doc': [null],
      'complaint_description': [null]
    });

    this.getComplaintList();
    this.activatedRoute.params.subscribe(params => {
      if (params['ipd_id'] && !params['complaint_id']) {
        this.IpdId = params['ipd_id'];
        this.patchPatientData();
        this.complaintForm.patchValue({
          'ipd_id': this.IpdId
        })
      }
      else if (params['ipd_id'] && params['complaint_id']) {
        this.ComplaintId = params['complaint_id'];
        this.IpdId = params['ipd_id'];
        this.patchPatientData();
        this.complaintForm.patchValue({
          'ipd_id': this.IpdId
        })
        this.patchComplaintData();
        this.showDocs=true;
      }

    });
  }

  selectAadhar(event)
  {
    const file = (event.target as HTMLInputElement).files[0];
    this.complaintForm.patchValue({
      hospital_infrastructure_com_doc: file
    });
  }

  ngOnInit(): void {
    this.myrole = localStorage.getItem('role');
    this.s3url = localStorage.getItem('s3url');
  }

  async patchPatientData() {
    await this.leadapi.viewIpdDetails(this.IpdId).subscribe((response: any) => {
      if (response.status) {
        this.userInformation.patchValue({
          'pname': response.data.patient,
          'treatment': response.data.treatment_name,
          'docname': response.data.doctor_name,
          'hospitalname': response.data.hospital_name,
          'bd_name': response.data.bd_name
        })
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  get f() { return this.complaintForm.controls; }
  get f1() { return this.userInformation.controls; }



  async getComplaintList() {
    await this.complaintapi.getAllComplaintList().subscribe((data: any) => {
      if (data.status) {
        let allComplaintList = data.data;

        for (var i = 0; i < allComplaintList.length; i++) {
          if (allComplaintList[i].complaint_category_id == 1) {
            this.bdComplaintList.push(allComplaintList[i]);
          }
          else if (allComplaintList[i].complaint_category_id == 2) {
            this.doctorComplaintList.push(allComplaintList[i]);
          }
          else if (allComplaintList[i].complaint_category_id == 3) {
            this.hInfrastructureComplaintList.push(allComplaintList[i]);
          }
          else if (allComplaintList[i].complaint_category_id == 4) {
            this.hStaffComplaintList.push(allComplaintList[i]);
          }
          else if (allComplaintList[i].complaint_category_id == 5) {
            this.admissionComplaintList.push(allComplaintList[i]);
          }
          else if (allComplaintList[i].complaint_category_id == 6) {
            this.dischargeComplaintList.push(allComplaintList[i]);
          }
          else if (allComplaintList[i].complaint_category_id == 7) {
            this.otherComplaintList.push(allComplaintList[i]);
          }
        }
      } else {
        this.complaintList = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async addComplaint() {
    this.submitted = true;
    this.loading = true;
    if (this.complaintForm.invalid) {
      this.loading = false;
      return;
    }
    //For Update complaint//
    if (this.ComplaintId) {
      this.complaintForm.value.ipd_id = parseInt(this.IpdId);
      await this.complaintapi.updateComplaint(this.complaintForm.value)
        .subscribe((data: any) => {
          this.submitted = false;
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast('Complaints Update Successfully');
            this.router.navigateByUrl('/complaints');
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    }
    else {
      console.log(this.complaintForm.controls);
      // for add complaint//
      this.complaintapi.addComplaint(this.complaintForm.value)
        .subscribe((data: any) => {
          this.submitted = false;
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast('Complaint Added Successfully');
            this.router.navigateByUrl('/complaints');
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });

    }


  }


  async patchComplaintData() {
    let ipdId = {
      "ipd_id": this.IpdId,
    }
    await this.complaintapi.getComplaintData(ipdId).subscribe((response: any) => {
      if (response.status) {
        // console.log(response.data);
        console.log("option_id", response.data.bd_option_id);
        this.complaintForm.patchValue({
          'bd_com': response.data.bd_option_id,
          'doctor_com': response.data.doctor_option_id,
          'hospital_infrastructure_com': response.data.hospital_infrastructure_option_id,
          'hospital_staff_com': response.data.hospital_staff_option_id,
          'admission_com': response.data.admission_option_id,
          'discharge_com': response.data.discharge_option_id,
          'others_com': response.data.others_option_id,
          'hospital_infrastructure_comp_doc': response.data.hospital_infrastructure_comp_doc,
          'complaint_description': response.data.complaint_description,
        });
        this.hospital_infrastructure_comp_doc = response.data.hospital_infrastructure_comp_doc;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }



}
